import { ChangeDetectionStrategy, Component, inject, output, signal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { AuthService } from "../auth/auth.service";

@Component({
  selector: "app-header",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  templateUrl: "./header.component.html"
})
export class HeaderComponent {
  
  private readonly auth = inject(AuthService);

  menuToggle = output<void>();
  profileOpen = signal(false);

  logout(): void {
    this.profileOpen.set(false);
    this.auth.logout();
  }

}
